import React, { useState } from 'react'
import { Checkbox, Flex, useToast } from '@chakra-ui/react'
import { useScoreStore } from '../../store/scoreStore'
import ScoreService from '../../API/ScoreService'

function CollectingScoresIsContacted({scoreData}) {
    const toast = useToast()
    const updateIsContacted = useScoreStore(state => state.updateIsContacted)
    const [isLoading, setIsLoading] = useState(false)

    const onCheckbox = async (e) => {
        const checked = e.target.checked
        setIsLoading(true)
        toast.promise(
            ScoreService.updateIsContacted(scoreData.site_id, checked),
            {
                success: (response) => {
                    updateIsContacted(response.data)
                    setIsLoading(false)
                    return { title: 'Статус изменен' }
                },
                error: () => {
                    setIsLoading(false)
                    return { title: 'Не удалось обновить статус' }
                },
                loading: { title: 'Изменение статуса...', position: 'top' }
            }
        )
    }

    return (
        <Flex justify='center' align='center'>
            <Checkbox
                colorScheme='orange'
                disabled={!scoreData || scoreData?.is_contacted === undefined || isLoading}
                isChecked={scoreData.is_contacted}
                onChange={onCheckbox}
            />
        </Flex>
    )
}

export default CollectingScoresIsContacted
